/* eslint-disable max-lines-per-function */
import React from 'react';
import PropTypes from 'prop-types'; // Add PropTypes for type checking
import { Select, MenuItem, Checkbox, ListItemText } from '@mui/material';
import ArrowDropDown from '../../Assets/images/svg/black_back_button.svg';

// Move IconComponent outside the YearDropdown component
const DropdownIcon = () => (
  <img src={ArrowDropDown} alt="Arrow Down" className="blogs-dropdown-icon" />
);

const YearDropdown = ({ years, selectedYears, handleYearChange, recentlySelected }) => {
  return (
    <div className="blogs-year-dropdown">
      <Select
        multiple
        value={selectedYears}
        onChange={handleYearChange}
        renderValue={(selected) => (selected.length > 0 ? selected.join(', ') : 'Select year')} // Placeholder when no selection
        className="blogs-dropdown-select"
        displayEmpty
        IconComponent={DropdownIcon} // Pass the external component here
        sx={{
          border: 'none', // Remove border
          borderBottom: '1px solid #ccc', // Add underline
          borderRadius: 0, // Remove border radius
          padding: 0, // Remove extra padding
          '&:hover': {
            borderBottom: '1px solid #000', // Darker underline on hover
          },
          '& .MuiSelect-select': {
            padding: '4px 0', // Adjust padding for a cleaner look
            color: selectedYears.length === 0 ? '#7A757F' : 'inherit',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none', // Remove the default outline
          },
        }}
      >
        {years.map((year) => (
          <MenuItem
            key={year}
            value={year}
            sx={{
              '&.Mui-selected': {
                backgroundColor: recentlySelected === year ? '#ECEDF4' : 'transparent', // Override selected background
                color: recentlySelected === year ? '#6B5CE8' : 'inherit', // Override selected text color
              },
            }}
          >
            <Checkbox
              checked={selectedYears.includes(year)} // Use includes for better readability
              sx={{
                color: '#7A757F', // Default color for unchecked state
                '&.Mui-checked': {
                  color: '#6b5ce8', // Checked state color
                },
              }}
            />
            <ListItemText
              primary={year}
              sx={{
                color: recentlySelected === year ? '#6B5CE8' : 'inherit', // Change text color only for the recently selected item
              }}
            />
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};

// Add PropTypes for type checking
YearDropdown.propTypes = {
  years: PropTypes.arrayOf(PropTypes.string).isRequired, // Array of years (strings)
  selectedYears: PropTypes.arrayOf(PropTypes.string).isRequired, // Array of selected years
  handleYearChange: PropTypes.func.isRequired, // Function to handle year selection
  recentlySelected: PropTypes.string, // Most recently selected year
};

// Default props for optional props
YearDropdown.defaultProps = {
  recentlySelected: null, // Default to null if no recently selected year
};

export default YearDropdown;
